export default __webpack_public_path__ + "static/email-hover-24ba969cfd64685b119be99568895a1a.webp";